import { useContext } from "react";
import { Typography, TextField, Stack, Grid, Checkbox } from "@mui/material";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { ValidateInt } from "../../../../../core/validator/Validator";

export const AnotherDetails = ({ handleChange, handleStrToIntChange }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { mainInfrmtn } = realproperty_state;

    const handleCbChange = (e) => {
        const { name, checked } = e.target;
        mainInfrmtn.set({
            ...mainInfrmtn.data,
            [name]: checked ? 1 : 0,
        })
    }

    const handlePriceChange = (e) => {
        const { name, value } = e.target;
        // to add comma
        let rawValue = value.replace(/,/g, ""); 
        let formattedValue = rawValue && !isNaN(rawValue) ? Number(rawValue).toLocaleString() : "";
        if (["price", "monthly", "yearly"].includes(name)) {
            const isValid = value !== "";
            mainInfrmtn.set({
                ...mainInfrmtn.data,
                [name]: {
                    ...mainInfrmtn.data[name],
                    value: formattedValue,
                    stat: !isValid,
                }
            })
        }
    }

    return (
        <Grid container spacing={2} mb="1rem">
            {/* 1 = Condominium, 2 = Commercial, 3 = Apartment, 4 = House, 5 = Land */}
            { [1,2,3,4].includes(mainInfrmtn.data.propertyType.value)  && 
                <Grid item xs={6}>
                    <Typography mb="0.5rem">
                        {
                            mainInfrmtn.data.propertyType.value === 1 ? "Condominium Name" :
                            mainInfrmtn.data.propertyType.value === 2 ? "Building Name" : "Subdivision Name" 
                        }
                    </Typography>
                    <TextField 
                        name = {
                            mainInfrmtn.data.propertyType.value === 1 ? "condominiumName" :
                            mainInfrmtn.data.propertyType.value === 2 ? "buildingName" : "subdivisionName" 
                        }
                        value = { 
                            mainInfrmtn.data[
                                mainInfrmtn.data.propertyType.value === 1 ? "condominiumName" : 
                                mainInfrmtn.data.propertyType.value === 2 ? "buildingName" : "subdivisionName"
                            ]
                        } 
                        onChange={(e) => handleChange(e, mainInfrmtn)} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }}/>
                </Grid>
            }
            { [1,2,3,4].includes(mainInfrmtn.data.propertyType.value) &&
                <Grid item xs={6}>
                    <Typography mb="0.5rem">{mainInfrmtn.data.propertyType.value === 1 ? "Unit No / Floor No." : "Block and Lot/Unit/Floor No."}</Typography>
                    <TextField name={mainInfrmtn.data.propertyType.value === 1 ? "unitNoFloorNo" : "blockLotUnitFloorNo"} value={mainInfrmtn.data[
                            mainInfrmtn.data.propertyType.value === 1 ? "unitNoFloorNo" : "blockLotUnitFloorNo"
                        ]} onChange={(e) => handleChange(e, mainInfrmtn)} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }}/>
                </Grid>
            }
            { (mainInfrmtn.data.propertyType.value === 1 || mainInfrmtn.data.propertyType.value === 4) &&
                <>
                    <Grid item xs={3}>
                        <Typography mb="0.5rem" >Bedroom</Typography>
                        <TextField name="bedroom" value={mainInfrmtn.data.bedroom} onChange={handleStrToIntChange} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography mb="0.5rem" >Bathroom</Typography>
                        <TextField name="bathroom" value={mainInfrmtn.data.bathroom} onChange={handleStrToIntChange} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                    </Grid>
                </>
            }
            { [1,2,3,4].includes(mainInfrmtn.data.propertyType.value) &&   
                <Grid item xs={3}>
                    <Typography mb="0.5rem">Floor Area (m²)</Typography>
                    <TextField name="floorArea" value={mainInfrmtn.data.floorArea} onChange={handleStrToIntChange} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                </Grid>
            }
            { [2,3,4,5].includes(mainInfrmtn.data.propertyType.value) &&  
                <Grid item xs={3}>
                    <Typography mb="0.5rem">Land Size (m²)</Typography>
                    <TextField name="landSize" value={mainInfrmtn.data.landSize} onChange={handleStrToIntChange} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                </Grid>
            }
            {mainInfrmtn.data.offerType.value === 1 &&
                <Grid item xs={12} display="flex" flexDirection="row">
                    <Stack width="100%" direction="row" alignItems="center">
                        <Checkbox name="forClosure" size="small" onChange={handleCbChange} checked={!!mainInfrmtn.data.forClosure} />
                        <Typography>For Foreclosure</Typography>
                    </Stack>
                    <Stack width="100%" direction="row" alignItems="center">
                        <Checkbox name="preSelling" size="small" onChange={handleCbChange} checked={!!mainInfrmtn.data.preSelling}/>
                        <Typography>For Pre-Selling</Typography>
                    </Stack>
                </Grid> 
            }
            {mainInfrmtn.data.offerType.value === 1 ?
                <Grid item xs={6}>
                    <Typography mb="0.5rem">Price (&#8369;)
                        <Typography component="span" color="error">*</Typography>
                    </Typography>
                    <TextField name="price" value={mainInfrmtn.data.price.value} onChange={handlePriceChange} error={mainInfrmtn.data.price.stat} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                </Grid>
            :
                <>
                    <Grid item xs={6}>
                        <Typography mb="0.5rem">Price per Month (&#8369;)
                            <Typography component="span" color="error">*</Typography>
                        </Typography>
                        <TextField name="monthly" value={mainInfrmtn.data.monthly.value} onChange={handlePriceChange} error={mainInfrmtn.data.monthly.stat} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography mb="0.5rem">Price per Year (&#8369;)
                            <Typography component="span" color="error">*</Typography>
                        </Typography>
                        <TextField name="yearly" value={mainInfrmtn.data.yearly.value} onChange={handlePriceChange} error={mainInfrmtn.data.yearly.stat} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }} onKeyPress={ValidateInt}/>
                    </Grid>
                </>
            }
            <Grid item xs={12}>
                <Stack direction="row" alignItems="center">
                    <Checkbox name="showPrice" size="small" onChange={handleCbChange} checked={!!mainInfrmtn.data.showPrice}/>
                    <Typography>Show Price Online</Typography>
                </Stack>
            </Grid>
            <Grid item xs={6}>
                <Typography mb="0.5rem">Available From
                    <Typography component="span" color="error">*</Typography>
                </Typography>
                <TextField name="availableFrom" type="date" value={mainInfrmtn.data.availableFrom.value} onChange={(e) => handleChange(e, mainInfrmtn)} error={mainInfrmtn.data.availableFrom.stat} label="" variant="outlined" fullWidth size="small" sx={{ bgcolor: "#fff" }}
                    inputProps={{
                    min: new Date().toISOString().split("T")[0], // today's date in YYYY-MM-DD
                    }}
                />
            </Grid>
        </Grid>
    )
}
